import { IUser } from "@deltasge/marauders-map";

export const getKeyEtapas = (usuario: IUser, anoLetivo: string) =>
  `etapas-${usuario.escolaId}-${anoLetivo}`;

export const getKeyTreeview = (usuario: IUser, anoLetivo: string) =>
  `treeview-${usuario.escolaId}-${anoLetivo}`;

export const getKeyEscola = (usuario: IUser) => `escola-${usuario.escolaId}`;

export const getKeyConfig = (usuario: IUser) => `config-${usuario.escolaId}`;

export const getKeyVersao = (usuario: IUser) => `versao-${usuario.escolaId}`;

export const getKeyMensagemCategoria = (usuario: IUser) =>
  `mensagem-categoria-${usuario.escolaId}`;

export const getKeyChatOptions = (usuario: IUser) =>
  `chat-options-${usuario.escolaId}`;
